import endpoints from './endpoints';

const host = '//localhost:5000';

// LOCAL
// const api = '//localhost:5000';
// const bucket = 'https://posillicocmsdevelop.blob.core.windows.net/development';

// STG
const api = 'https://posillico-cms-stg-b75cfbee0a17.herokuapp.com';
const bucket = 'https://posillicocmsstorage.blob.core.windows.net/production';

export default {
	host,
	api,
	bucket,

	endpoints: endpoints(api),
};
